import styled from "styled-components";
import { setFlex, setPosition } from "../variables/utils";

export const Wrapper = styled.div`
  ${setPosition({ position: "relative" })};
  width: 100%;
  height: 200vh;
  opacity: 0;
  &.active {
    opacity: 1;
  }
`;

export const Container = styled.div`
  ${setFlex({ align: "center", direction: "column" })};
  width: 100%;
  height: 200vh;
`;

export const HeroImage = styled.img`
  width: 100%;
  height: auto;
`;

export const Headline = styled.h1`
  ${setPosition({ position: "absolute", top: "0" })};
  ${setFlex({ justify: "center", align: "center", direction: "column" })};
  height: 100vh;
  font-family: univers-roman;
`;

export const Paragraph = styled.p`
  font-family: univers-light;
`;

export const VideoContainer = styled.div`
  width: 100%;
  height: 100%;
`;
